/* ==========================================================================
   Aero Tienda · JS del rediseño
   Delegación de eventos: funciona con contenido re-renderizado (carrito,
   "cargar más", editor de temas) sin volver a enlazar.
   API pública: window.AT.cart.add(items) · AT.cart.refresh() · AT.drawer.open(id)
   · AT.drawer.close(id) · AT.toast(msg) · AT.formatMoney(cents)
   ========================================================================== */
(function () {
  'use strict';
  var AT = (window.AT = window.AT || {});
  var routes = AT.routes || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', search: '/search', predictiveSearch: '/search/suggest' };
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ---------- dinero ---------- */
  AT.formatMoney = function (cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var fmt = String(format || AT.money || '${{amount}}').replace(/<[^>]*>/g, '');
    function delimit(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var c = parts[1] ? decimal + parts[1] : '';
      return dollars + c;
    }
    var m = fmt.match(placeholder);
    switch (m ? m[1] : 'amount') {
      case 'amount': value = delimit(cents, 2); break;
      case 'amount_no_decimals': value = delimit(cents, 0); break;
      case 'amount_with_comma_separator': value = delimit(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delimit(cents, 0, '.', ','); break;
      default: value = delimit(cents, 2);
    }
    var out = fmt.replace(placeholder, value);
    // Precios cerrados: $34,490.00 -> $34,490
    return out.replace(/\.00(?!\d)/, '');
  };

  /* ---------- fechas de entrega ----------
     Misma regla que snippets/at-delivery-estimate.liquid (la página puede venir de caché):
     días hábiles = lunes a viernes sin festivos oficiales; hora de corte 2:30 p. m., hora del centro de México
     (UTC−6 fijo). Antes del corte en día hábil se procesa hoy; si no, desde el siguiente día hábil.
     Elementos: [data-at-eta="5-8"] (rango de días hábiles), [data-at-eta-f] (día s|l + mes s|l: "sl" = "vie 2 … de octubre"),
     [data-at-eta-d] opcional = hoy | llega | reporta (+5 días naturales) | plazo30 (+30). */
  AT.eta = (function () {
    var DAY = 864e5, CUT = 14 * 60 + 30;
    var WS = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'];
    var WL = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
    var MS = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
    var ML = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
    // Las fechas se manejan como mediodía UTC del día de México: se leen con getUTC*
    function nthMonday(y, m, n) { var w = new Date(Date.UTC(y, m, 1)).getUTCDay(); return 1 + (8 - w) % 7 + (n - 1) * 7; }
    function isBiz(d) {
      var w = d.getUTCDay(), m = d.getUTCMonth(), day = d.getUTCDate(), y = d.getUTCFullYear();
      if (w === 0 || w === 6) return false;
      if ((m === 0 && day === 1) || (m === 4 && day === 1) || (m === 8 && day === 16) || (m === 11 && day === 25)) return false;
      if ((m === 1 && day === nthMonday(y, 1, 1)) || (m === 2 && day === nthMonday(y, 2, 3)) || (m === 10 && day === nthMonday(y, 10, 3))) return false;
      if (m === 9 && day === 1 && (y - 2024) % 6 === 0) return false;
      return true;
    }
    function calc(min, max, nowMs) {
      var mx = new Date((nowMs || Date.now()) - 6 * 36e5);
      var today = new Date(Date.UTC(mx.getUTCFullYear(), mx.getUTCMonth(), mx.getUTCDate(), 12));
      var start = today;
      if (!isBiz(today) || mx.getUTCHours() * 60 + mx.getUTCMinutes() >= CUT) {
        do { start = new Date(start.getTime() + DAY); } while (!isBiz(start));
      }
      var d = start, n = 0, a = start, b = start;
      while (n < max) { d = new Date(d.getTime() + DAY); if (isBiz(d)) { n++; if (n === min) a = d; if (n === max) b = d; } }
      return { today: today, start: start, a: a, b: b };
    }
    function day(d, f) { return (f.charAt(0) === 'l' ? WL : WS)[d.getUTCDay()] + ' ' + d.getUTCDate(); }
    function mon(d, f) { return (f.charAt(1) === 's' ? MS : ML)[d.getUTCMonth()]; }
    function one(d, f) { return day(d, f) + ' de ' + mon(d, f); }
    function range(r, f) {
      return 'entre el ' + day(r.a, f) + (r.a.getUTCMonth() !== r.b.getUTCMonth() ? ' de ' + mon(r.a, f) : '') + ' y el ' + day(r.b, f) + ' de ' + mon(r.b, f);
    }
    function text(min, max, f, kind, nowMs) {
      var r = calc(min, max, nowMs);
      if (kind === 'hoy') return one(r.today, f);
      if (kind === 'llega') return one(r.a, f);
      if (kind === 'reporta') return one(new Date(r.a.getTime() + 5 * DAY), f);
      if (kind === 'plazo30') return one(new Date(r.a.getTime() + 30 * DAY), f);
      return range(r, f);
    }
    function apply(ctx) {
      $$('[data-at-eta]', ctx).forEach(function (el) {
        var p = String(el.getAttribute('data-at-eta') || '5-8').split('-');
        var t = text(parseInt(p[0], 10) || 5, parseInt(p[1], 10) || 8, el.getAttribute('data-at-eta-f') || 'sl', el.getAttribute('data-at-eta-d'));
        if (el.textContent !== t) el.textContent = t;
      });
    }
    return { isBiz: isBiz, calc: calc, text: text, apply: apply };
  })();

  /* ---------- aviso ---------- */
  var toastTimer;
  AT.toast = function (msg) {
    var el = $('[data-at-toast]');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-on'); }, 2600);
  };

  /* ---------- cajones ---------- */
  var lastFocus = null;
  AT.drawer = {
    open: function (id) {
      var d = document.getElementById(id);
      if (!d) return;
      lastFocus = document.activeElement;
      d.classList.add('is-open');
      d.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('at-no-scroll');
      $$('[data-at-open="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      var focusable = d.querySelector('[data-at-autofocus]') || d.querySelector('button, [href], input, select, textarea');
      if (focusable) setTimeout(function () { focusable.focus(); }, 60);
    },
    close: function (id) {
      var d = id ? document.getElementById(id) : $('.at-drawer.is-open');
      if (!d) return;
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
      if (!$('.at-drawer.is-open')) document.documentElement.classList.remove('at-no-scroll');
      $$('[data-at-open="' + d.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
  };
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-at-open]');
    if (opener) { e.preventDefault(); AT.drawer.open(opener.getAttribute('data-at-open')); return; }
    var closer = e.target.closest('[data-at-close]');
    if (closer) { e.preventDefault(); AT.drawer.close(closer.getAttribute('data-at-close') || (closer.closest('.at-drawer') || {}).id); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if ($('.at-drawer.is-open')) AT.drawer.close();
      $$('[data-at-mega].is-open').forEach(function (m) { m.classList.remove('is-open'); var b = m.querySelector('[data-at-mega-toggle]'); if (b) b.setAttribute('aria-expanded', 'false'); });
    }
  });

  /* ---------- mega menú (escritorio): clic/teclado; el hover va por CSS ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-at-mega-toggle]');
    $$('[data-at-mega].is-open').forEach(function (m) { if (!t || !m.contains(t)) { m.classList.remove('is-open'); var b = m.querySelector('[data-at-mega-toggle]'); if (b) b.setAttribute('aria-expanded', 'false'); } });
    if (!t) return;
    e.preventDefault();
    var item = t.closest('[data-at-mega]');
    var open = !item.classList.contains('is-open');
    item.classList.toggle('is-open', open);
    t.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ---------- cantidad ---------- */
  function clampQty(input, v) {
    var min = parseInt(input.getAttribute('min') || '1', 10);
    var max = parseInt(input.getAttribute('max') || '999', 10);
    v = parseInt(v, 10);
    if (isNaN(v)) v = min;
    return Math.max(min, Math.min(max, v));
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-at-qty-minus],[data-at-qty-plus]');
    if (!b) return;
    var wrap = b.closest('[data-at-qty]');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    e.preventDefault();
    var next = clampQty(input, (parseInt(input.value, 10) || 0) + (b.hasAttribute('data-at-qty-plus') ? 1 : -1));
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-at-qty] input');
    if (!input) return;
    input.value = clampQty(input, input.value);
    var wrap = input.closest('[data-at-qty]');
    var minus = wrap.querySelector('[data-at-qty-minus]');
    if (minus) minus.disabled = parseInt(input.value, 10) <= parseInt(input.getAttribute('min') || '1', 10);
  });

  /* ---------- carrusel ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-at-prev],[data-at-next]');
    if (!b) return;
    var root = b.closest('[data-at-carousel]');
    var track = root && root.querySelector('[data-at-track]');
    if (!track) return;
    e.preventDefault();
    var first = track.firstElementChild;
    var step = first ? first.getBoundingClientRect().width + 12 : track.clientWidth * 0.8;
    track.scrollBy({ left: b.hasAttribute('data-at-next') ? step : -step, behavior: 'smooth' });
  });

  /* ---------- galería ---------- */
  function galleryGo(g, idx) {
    var slides = $$('[data-at-slide]', g);
    if (!slides.length) return;
    idx = (idx + slides.length) % slides.length;
    slides.forEach(function (s, i) { s.classList.toggle('is-on', i === idx); s.setAttribute('aria-hidden', i === idx ? 'false' : 'true'); });
    $$('[data-at-thumb]', g).forEach(function (t, i) { t.classList.toggle('is-on', i === idx); t.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
    var c = $('[data-at-gallery-count]', g);
    if (c) c.textContent = (idx + 1) + ' / ' + slides.length;
    g.setAttribute('data-index', idx);
  }
  AT.galleryToMedia = function (g, mediaId) {
    if (!g || !mediaId) return;
    var slides = $$('[data-at-slide]', g);
    for (var i = 0; i < slides.length; i++) { if (String(slides[i].getAttribute('data-media-id')) === String(mediaId)) { galleryGo(g, i); return; } }
  };
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-at-thumb]');
    if (t) { var g = t.closest('[data-at-gallery]'); galleryGo(g, $$('[data-at-thumb]', g).indexOf(t)); return; }
    var n = e.target.closest('[data-at-gallery-prev],[data-at-gallery-next]');
    if (n) {
      var g2 = n.closest('[data-at-gallery]');
      var cur = parseInt(g2.getAttribute('data-index') || '0', 10);
      galleryGo(g2, cur + (n.hasAttribute('data-at-gallery-next') ? 1 : -1));
    }
  });
  // deslizar con el dedo en la foto principal
  var touchX = null;
  document.addEventListener('touchstart', function (e) { if (e.target.closest('[data-at-gallery-main]')) touchX = e.touches[0].clientX; }, { passive: true });
  document.addEventListener('touchend', function (e) {
    if (touchX === null) return;
    var main = e.target.closest('[data-at-gallery-main]');
    var dx = e.changedTouches[0].clientX - touchX;
    touchX = null;
    if (!main || Math.abs(dx) < 40) return;
    var g = main.closest('[data-at-gallery]');
    galleryGo(g, parseInt(g.getAttribute('data-index') || '0', 10) + (dx < 0 ? 1 : -1));
  }, { passive: true });

  /* ---------- variantes ---------- */
  function readProduct(root) {
    var s = root.querySelector('script[data-at-product-json]');
    if (!s) return null;
    if (!root._atProduct) { try { root._atProduct = JSON.parse(s.textContent); } catch (err) { root._atProduct = null; } }
    return root._atProduct;
  }
  function currentOptions(picker) {
    var opts = [];
    $$('[data-at-option]', picker).forEach(function (field) {
      var pos = parseInt(field.getAttribute('data-at-option'), 10);
      var val = null;
      if (field.tagName === 'SELECT') val = field.value;
      else { var checked = field.querySelector('input:checked'); if (checked) val = checked.value; }
      opts[pos - 1] = val;
    });
    return opts;
  }
  function updateVariant(root) {
    var product = readProduct(root);
    var picker = root.querySelector('[data-at-variant-picker]');
    if (!product || !picker) return;
    var opts = currentOptions(picker);
    var variant = null;
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i], ok = true;
      for (var j = 0; j < opts.length; j++) { if (opts[j] != null && v.options[j] !== opts[j]) { ok = false; break; } }
      if (ok) { variant = v; break; }
    }
    // etiquetas de la opción elegida
    $$('[data-at-option-label]', root).forEach(function (el) { var p = parseInt(el.getAttribute('data-at-option-label'), 10); el.textContent = opts[p - 1] || ''; });
    // marcar valores sin combinación disponible
    $$('[data-at-option]', picker).forEach(function (field) {
      var pos = parseInt(field.getAttribute('data-at-option'), 10) - 1;
      $$('input[type="radio"]', field).forEach(function (inp) {
        var test = opts.slice(); test[pos] = inp.value;
        var exists = product.variants.some(function (v) { return test.every(function (o, k) { return o == null || v.options[k] === o; }) && v.available; });
        inp.parentNode.classList.toggle('is-unavailable', !exists);
      });
    });
    var idInput = root.querySelector('input[name="id"]');
    var btns = $$('[data-at-add]', root);
    if (!variant) {
      btns.forEach(function (b) { b.disabled = true; b.textContent = AT.strings.unavailable; });
      return;
    }
    if (idInput) { idInput.value = variant.id; idInput.dispatchEvent(new Event('change', { bubbles: true })); }
    $$('[data-at-price]', root).forEach(function (el) { el.textContent = AT.formatMoney(variant.price); });
    $$('[data-at-compare]', root).forEach(function (el) {
      var show = variant.compare_at_price && variant.compare_at_price > variant.price;
      el.textContent = show ? AT.formatMoney(variant.compare_at_price) : '';
      el.hidden = !show;
    });
    $$('[data-at-save]', root).forEach(function (el) {
      var show = variant.compare_at_price && variant.compare_at_price > variant.price;
      el.hidden = !show;
      if (show) el.textContent = 'Ahorras ' + AT.formatMoney(variant.compare_at_price - variant.price);
    });
    $$('[data-at-msi]', root).forEach(function (el) {
      var show = variant.price >= 2000000;
      el.hidden = !show;
      if (show) el.textContent = 'Hasta 12 MSI de ' + AT.formatMoney(Math.round(variant.price / 1200) * 100);
    });
    $$('[data-at-oxxo]', root).forEach(function (el) { el.hidden = variant.price > 1000000; });
    $$('[data-at-sku]', root).forEach(function (el) { el.textContent = variant.sku || ''; el.parentNode.hidden = !variant.sku; });
    btns.forEach(function (b) {
      b.disabled = !variant.available;
      var label = b.querySelector('[data-at-add-label]') || b;
      label.textContent = variant.available ? (b.getAttribute('data-label') || AT.strings.addToCart) : AT.strings.soldOut;
    });
    if (variant.featured_media) AT.galleryToMedia(root.querySelector('[data-at-gallery]'), variant.featured_media.id);
    if (root.hasAttribute('data-at-update-url') && window.history && history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url.toString());
    }
    root.dispatchEvent(new CustomEvent('at:variant', { bubbles: true, detail: { variant: variant } }));
  }
  document.addEventListener('change', function (e) {
    var field = e.target.closest('[data-at-option]');
    if (!field) return;
    var root = field.closest('[data-at-product]');
    if (root) updateVariant(root);
  });

  /* ---------- carrito ---------- */
  function cartSections() {
    return $$('[data-at-cart-section]').map(function (el) { return el.getAttribute('data-at-cart-section'); }).filter(function (v, i, a) { return v && a.indexOf(v) === i; });
  }
  function renderSections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var html = sections[id];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      $$('[data-at-cart-section="' + id + '"]').forEach(function (target) {
        var fresh = doc.querySelector('[data-at-cart-section="' + id + '"]');
        if (fresh) { target.innerHTML = fresh.innerHTML; AT.eta.apply(target); }
      });
    });
  }
  // Servicios (Protección de Envío, Garantía Extendida) no cuentan como productos en la bolsa
  var AT_SERVICES = ['seguro-de-envio', 'garantia-extendida-de-2-anos', 'garantia-extendida-por-1-ano', 'garantia-de-1-ano-copy', 'garantia-de-1-ano'];
  function countOf(cart) {
    if (!cart || !cart.items) return cart && cart.item_count ? cart.item_count : 0;
    return cart.items.reduce(function (n, it) { return AT_SERVICES.indexOf(it.handle) === -1 ? n + it.quantity : n; }, 0);
  }
  function updateCount(cart) {
    var count = typeof cart === 'number' ? cart : countOf(cart);
    $$('[data-at-cart-count]').forEach(function (el) { el.textContent = count > 0 ? count : ''; el.setAttribute('data-count', count); });
  }
  function fetchJSON(url, opts) {
    return fetch(url, opts).then(function (r) {
      // Si la respuesta no es JSON (p. ej. una página de error o de espera de la tienda), se trata como error con aviso, sin romper la página
      return r.text().then(function (txt) {
        var data = null;
        try { data = txt ? JSON.parse(txt) : {}; } catch (e) { data = null; }
        if (!r.ok || data === null) {
          var err = new Error((data && (data.description || data.message)) || 'error');
          err.data = data || {};
          err.status = r.status;
          throw err;
        }
        return data;
      });
    });
  }
  AT.cart = {
    add: function (items, opts) {
      opts = opts || {};
      var body = { items: items, sections: cartSections().join(','), sections_url: window.location.pathname };
      return fetchJSON(routes.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (res) {
          renderSections(res.sections);
          // Si /cart.js falla después de agregar, el producto sí se agregó: seguimos sin marcar error
          return AT.cart.get().catch(function () { return null; }).then(function (cart) {
            if (cart) updateCount(cart);
            if (opts.open !== false) {
              if (document.getElementById('AtCartDrawer') && !document.body.classList.contains('template-cart')) AT.drawer.open('AtCartDrawer');
              else if (document.body.classList.contains('template-cart')) window.location.reload();
              else AT.toast(AT.strings.added);
            }
            document.dispatchEvent(new CustomEvent('at:cart:updated', { detail: { cart: cart } }));
            return cart;
          });
        });
    },
    change: function (key, quantity) {
      var body = { id: key, quantity: quantity, sections: cartSections().join(','), sections_url: window.location.pathname };
      return fetchJSON(routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (cart) {
          renderSections(cart.sections);
          updateCount(cart);
          document.dispatchEvent(new CustomEvent('at:cart:updated', { detail: { cart: cart } }));
          return cart;
        });
    },
    get: function () { return fetchJSON(routes.cart + '.js', { headers: { Accept: 'application/json' } }); },
    refresh: function () {
      var ids = cartSections();
      if (!ids.length) return Promise.resolve();
      return fetch(window.location.pathname + '?sections=' + ids.join(',')).then(function (r) { return r.json(); }).then(function (s) {
        renderSections(s);
        return AT.cart.get().then(function (cart) { updateCount(cart); });
      });
    }
  };

  // Formularios de producto: <form action="/cart/add" data-at-product-form>
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-at-product-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.classList.add('is-loading');
    var fd = new FormData(form);
    var item = { id: parseInt(fd.get('id'), 10), quantity: parseInt(fd.get('quantity') || '1', 10) || 1 };
    var props = {};
    fd.forEach(function (v, k) { var m = k.match(/^properties\[(.+)\]$/); if (m && String(v).trim() !== '') props[m[1]] = v; });
    if (Object.keys(props).length) item.properties = props;
    var items = [item];
    // complementos marcados en la misma forma: <input type="checkbox" data-at-addon-variant="123" checked>
    $$('[data-at-addon-variant]', form).forEach(function (a) { if (a.checked) items.push({ id: parseInt(a.getAttribute('data-at-addon-variant'), 10), quantity: 1 }); });
    AT.cart.add(items).catch(function (err) {
      AT.toast((err && err.data && err.data.description) || AT.strings.error);
    }).then(function () { if (btn) btn.classList.remove('is-loading'); });
  });

  // Botón "Comprar ahora": agrega y va al checkout
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-at-buy-now]');
    if (!b) return;
    var form = b.closest('form[data-at-product-form]') || document.getElementById(b.getAttribute('form'));
    if (!form) return;
    e.preventDefault();
    var fd = new FormData(form);
    var item = { id: parseInt(fd.get('id'), 10), quantity: parseInt(fd.get('quantity') || '1', 10) || 1 };
    AT.cart.add([item], { open: false }).then(function () { window.location.href = '/checkout'; }).catch(function (err) { AT.toast((err && err.data && err.data.description) || AT.strings.error); });
  });

  // Líneas del carrito: cantidad y quitar (data-at-line="KEY")
  // Si el cambio falla, avisa y vuelve a pintar el carrito con lo que de verdad tiene
  function lineFail(err) {
    AT.toast((err && err.data && err.data.description) || 'No se pudo actualizar tu carrito. Intenta de nuevo o escríbenos por WhatsApp.');
    AT.cart.refresh().catch(function () {});
  }
  var lineTimer;
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-at-line] input[data-at-line-qty]');
    if (!input) return;
    var key = input.closest('[data-at-line]').getAttribute('data-at-line');
    clearTimeout(lineTimer);
    lineTimer = setTimeout(function () { AT.cart.change(key, parseInt(input.value, 10) || 0).catch(lineFail); }, 250);
  });
  document.addEventListener('click', function (e) {
    var r = e.target.closest('[data-at-line-remove]');
    if (!r) return;
    e.preventDefault();
    AT.cart.change(r.closest('[data-at-line]').getAttribute('data-at-line'), 0).catch(lineFail);
  });
  // Complementos opcionales en el carrito (Protección de Envío, Garantía Extendida):
  // <input type="checkbox" data-at-cart-addon="VARIANT_ID" data-line-key="KEY si ya está">
  document.addEventListener('change', function (e) {
    var a = e.target.closest('[data-at-cart-addon]');
    if (!a) return;
    var vid = parseInt(a.getAttribute('data-at-cart-addon'), 10);
    a.disabled = true;
    var p;
    if (a.checked) p = AT.cart.add([{ id: vid, quantity: 1 }], { open: false });
    else {
      var key = a.getAttribute('data-line-key');
      p = key ? AT.cart.change(key, 0) : AT.cart.get().then(function (cart) {
        var line = cart.items.filter(function (i) { return i.variant_id === vid; })[0];
        return line ? AT.cart.change(line.key, 0) : null;
      });
    }
    p.catch(function () { AT.toast(AT.strings.error); a.checked = !a.checked; }).then(function () { a.disabled = false; });
  });

  /* ---------- cargar más (paginación progresiva) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-at-load-more]');
    if (!b) return;
    var url = b.getAttribute('data-next-url');
    var grid = document.querySelector(b.getAttribute('data-target') || '[data-at-grid]');
    if (!url || !grid) return;
    e.preventDefault();
    b.classList.add('is-loading');
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector(b.getAttribute('data-target') || '[data-at-grid]');
      if (fresh) Array.prototype.slice.call(fresh.children).forEach(function (c) { grid.appendChild(c); });
      var nextBtn = doc.querySelector('[data-at-load-more]');
      var shown = doc.querySelector('[data-at-shown]');
      $$('[data-at-shown]').forEach(function (el) { if (shown) el.innerHTML = shown.innerHTML; });
      if (nextBtn && nextBtn.getAttribute('data-next-url')) { b.setAttribute('data-next-url', nextBtn.getAttribute('data-next-url')); b.classList.remove('is-loading'); }
      else { b.hidden = true; var done = document.querySelector('[data-at-all-shown]'); if (done) done.hidden = false; }
    }).catch(function () { b.classList.remove('is-loading'); window.location.href = url; });
  });

  /* ---------- búsqueda predictiva ---------- */
  var searchTimer;
  document.addEventListener('input', function (e) {
    var input = e.target.closest('[data-at-search-input]');
    if (!input) return;
    var root = input.closest('[data-at-search]');
    var out = root && root.querySelector('[data-at-search-results]');
    if (!out) return;
    var q = input.value.trim();
    clearTimeout(searchTimer);
    if (q.length < 2) { out.innerHTML = ''; out.hidden = true; return; }
    searchTimer = setTimeout(function () {
      var url = routes.predictiveSearch + '?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,page,article&resources[limit]=6&resources[limit_scope]=each&resources[options][unavailable_products]=last&section_id=at-predictive-search';
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var content = doc.querySelector('[data-at-predictive]');
        out.innerHTML = content ? content.innerHTML : '';
        out.hidden = !content;
      }).catch(function () { out.hidden = true; });
    }, 220);
  });
  document.addEventListener('click', function (e) {
    $$('[data-at-search-results]').forEach(function (out) { if (!out.closest('[data-at-search]').contains(e.target)) out.hidden = true; });
  });

  /* ---------- pestañas de contenido (no ancla) ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-at-tabs] [role="tab"]');
    if (!t) return;
    var tabs = t.closest('[data-at-tabs]');
    var scope = tabs.closest('[data-at-tabs-scope]') || tabs.parentNode;
    $$('[role="tab"]', tabs).forEach(function (x) { var on = x === t; x.setAttribute('aria-selected', on ? 'true' : 'false'); x.classList.toggle('is-on', on); var p = scope.querySelector('#' + x.getAttribute('aria-controls')); if (p) p.hidden = !on; });
  });

  /* ---------- barra fija de compra (móvil) ---------- */
  function initSticky() {
    $$('[data-at-sticky]').forEach(function (bar) {
      if (bar._atInit) return;
      bar._atInit = true;
      var target = document.querySelector(bar.getAttribute('data-at-sticky'));
      if (!target || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (entries) {
        var out = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        bar.classList.toggle('is-on', out);
        document.body.classList.toggle('at-has-sticky', out);
      }).observe(target);
    });
  }

  /* ---------- inicio y editor de temas ---------- */
  function init(ctx) {
    AT.eta.apply(ctx);
    initSticky();
    $$('[data-at-product]', ctx || document).forEach(function (root) { if (root.querySelector('[data-at-variant-picker]')) updateVariant(root); });
    $$('[data-at-gallery]', ctx || document).forEach(function (g) { if (!g.hasAttribute('data-index')) galleryGo(g, 0); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
